export const CABLE_DEF = { napowietrzny: "#3B82F6", kanalizacja: "#F59E0B", "kanalizacja OPL": "#F97316", "kanalizacja własna": "#EAB308", mikrokanalizacja: "#22C55E", doziemny: "#8B5CF6" };

export const ductColor = (cableColors) => ({ ...CABLE_DEF, ...(cableColors || {}) }).kanalizacja;
export const microductColor = (cableColors) => ({ ...CABLE_DEF, ...(cableColors || {}) }).mikrokanalizacja;
